import { memo, useRef, useState } from 'react';

const InfoRoundButton = ({
  message,
  onClick,
  icon = 'info',
  disabled = false,
}) => {
  const buttonRef = useRef(null);

  const [showTooltip, setShowTooltip] = useState(false);

  const [tooltipPos, setTooltipPos] = useState({
    top: 0,
    left: 0,
  });

  const handleMouseEnter = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();

      setTooltipPos({
        top: rect.top + rect.height / 2,
        left: rect.right + 10,
      });
    }

    setShowTooltip(true);
  };

  return (
    <>
      <style>
        {`
          .info-round-button {
            width: 18px;
            height: 18px;

            min-width: 18px;
            min-height: 18px;

            margin-left: 5px;
            margin-right: 3px;

            border: none;
            border-radius: 50%;

            background: #7f7f7f;
            color: white;

            display: inline-flex;
            align-items: center;
            justify-content: center;

            padding: 0;

            cursor: pointer;
          }

          .info-round-button i {
            font-size: 8px;
          }

          .custom-info-tooltip {
            position: fixed;

            background: rgba(0, 0, 0, 0.92);
            color: white;

            padding: 6px 10px;

            border-radius: 4px;

            font-size: 12px;

            white-space: nowrap;

            transform: translateY(-50%);

            z-index: 999999;

            pointer-events: none;

            opacity: 0;
            visibility: hidden;

            transition: opacity 0.12s ease;
          }

          .custom-info-tooltip.show {
            opacity: 1;
            visibility: visible;
          }
        `}
      </style>

      <>
        <button
          ref={buttonRef}
          type="button"
          onClick={onClick}
          disabled={disabled}
          aria-label={message}
          className="info-round-button"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <i className={`fa fa-${icon} fa-fw`} />
        </button>

        <div
          className={`custom-info-tooltip ${
            showTooltip ? 'show' : ''
          }`}
          style={{
            top: tooltipPos.top,
            left: tooltipPos.left,
          }}
        >
          {message}
        </div>
      </>
    </>
  );
};

export default memo(InfoRoundButton);